@if (payments != null && payments.length > 0) {
  <div class="grid-x margin-top margin-bottom">
    <div class="cell large-8 medium-8 small-6 bold text-align-center">
      Description
    </div>
    <div class="cell large-4 medium-4 small-6 bold text-align-right">
      Fee
    </div>
    @for (payment of payments; track payment) {
      <div class="cell large-8 medium-8 small-6 bold text-align-left">
        {{payment.description}}
      </div>
      <div class="cell large-4 medium-4 small-6 bold text-align-right">
        {{payment.fee | currency:'USD': 'symbol': '1.2-2'}}
      </div>
    }
    <div class="cell large-8 medium-8 small-6 bold border-top-bottom">
      Total:
    </div>
    <div class="cell large-4 medium-4 small-6 bold border-top text-align-right">
      {{ totalFees | currency:'USD': 'symbol': '1.2-2'}}
    </div>
  </div>
}